import { render, staticRenderFns } from "./ProjectionForm.vue?vue&type=template&id=738b10c2&"
import script from "./ProjectionForm.vue?vue&type=script&lang=js&"
export * from "./ProjectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports